var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmobiAcGyors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 12.381C23.75 19.0412 18.3809 25.4265 12.0025 29.6979C5.16984 24.9644 0.25 19.0453 0.25 12.381C0.25 5.67379 5.51796 0.25 12 0.25C18.482 0.25 23.75 5.67379 23.75 12.381Z",
    fill: "white",
    stroke: "#4DABE9",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.5C8.27208 7.5 5.25 10.5221 5.25 14.25C5.25 14.6642 4.91421 15 4.5 15C4.08579 15 3.75 14.6642 3.75 14.25C3.75 9.69365 7.44365 6 12 6C16.5563 6 20.25 9.69365 20.25 14.25C20.25 14.6642 19.9142 15 19.5 15C19.0858 15 18.75 14.6642 18.75 14.25C18.75 10.5221 15.7279 7.5 12 7.5Z",
    fill: "#4DABE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.625 16.5C9.24632 16.5 9.75 15.9963 9.75 15.375C9.75 14.7537 9.24632 14.25 8.625 14.25C8.00368 14.25 7.5 14.7537 7.5 15.375C7.5 15.9963 8.00368 16.5 8.625 16.5ZM8.625 18C10.0747 18 11.25 16.8247 11.25 15.375C11.25 13.9253 10.0747 12.75 8.625 12.75C7.17525 12.75 6 13.9253 6 15.375C6 16.8247 7.17525 18 8.625 18Z",
    fill: "#4DABE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.375 16.5C15.9963 16.5 16.5 15.9963 16.5 15.375C16.5 14.7537 15.9963 14.25 15.375 14.25C14.7537 14.25 14.25 14.7537 14.25 15.375C14.25 15.9963 14.7537 16.5 15.375 16.5ZM15.375 18C16.8247 18 18 16.8247 18 15.375C18 13.9253 16.8247 12.75 15.375 12.75C13.9253 12.75 12.75 13.9253 12.75 15.375C12.75 16.8247 13.9253 18 15.375 18Z",
    fill: "#4DABE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmobiAcGyors);
export default __webpack_public_path__ + "static/media/emobi_ac_gyors.74f5f2c2005ba1710bc7185c33346e99.svg";
export { ForwardRef as ReactComponent };